import React from 'react';

import ActivityIndicator from '~/UI/ActivityIndicator/ActivityIndicator';
import Loadable from 'react-loadable';

const LoadingSpinner: React.FC<Record<never, never>> = () => <ActivityIndicator />;

const LoadableERPChartContainer = Loadable({
	loader: () => import(/* webpackChunkName: "erp-chart-container",  webpackPrefetch: true */ './ERPChartContainer'),
	loading: LoadingSpinner,
});

LoadableERPChartContainer.displayName = 'MedicinalBrandsAnalytics.ERPChart.LoadableERPChartContainer';

export default LoadableERPChartContainer;
